"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PlayerStatisticsDetailsCtl_1 = require("../../../../main_players_list/ctl/PlayerStatisticsDetailsCtl");
var DepositReqDetailExpander = /** @class */ (function (_super) {
    __extends(DepositReqDetailExpander, _super);
    function DepositReqDetailExpander(props) {
        var _this = _super.call(this, props) || this;
        _this.SDetails = null;
        _this.SID = 0;
        return _this;
    }
    DepositReqDetailExpander.prototype.componentWillMount = function () {
        var _this = this;
        this.SDetails = new PlayerStatisticsDetailsCtl_1.PlayerStatisticsDetailsCtl(this.props.state.getErrDialog());
        this.SID = this.SDetails.Subscribe("*", function (id, data) {
            _this.setState({ Data: _this.SDetails.DATA });
        });
        this.setState({
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            if (_this.props.data.player_id > 0) {
                _this.SDetails.LoadDataByDeposit({
                    money_flow_key: _this.props.data.key,
                    from_year: _this.state.dtFrom.get('year'),
                    from_month: _this.state.dtFrom.get('month') + 1,
                    from_day: _this.state.dtFrom.get('date'),
                    to_year: _this.state.dtTo.get('year'),
                    to_month: _this.state.dtTo.get('month') + 1,
                    to_day: _this.state.dtTo.get('date'),
                });
            }
        });
    };
    DepositReqDetailExpander.prototype.componentWillUnmount = function () {
        this.SDetails.UnSubscribe(this.SID);
    };
    DepositReqDetailExpander.prototype.buttonClick = function () {
        // if (this.props.onClick) {
        //     this.props.onClick();
        // }
    };
    DepositReqDetailExpander.prototype.getTotalRtp = function () {
        if (this.SDetails.DATA.total_bet_money_amount == 0) {
            return "0%";
        }
        var dt = this.SDetails.DATA.total_bet_money_amount - this.SDetails.DATA.total_win_money_amount;
        dt = (1 - dt / this.SDetails.DATA.total_bet_money_amount) * 100;
        return dt.toFixed(2);
    };
    DepositReqDetailExpander.prototype.getCustomZone = function () {
        if (this.SDetails.DATA.is_custom_zone) {
            return this.SDetails.DATA.custom_zone_title;
        }
        else {
            return "Нет";
        }
    };
    DepositReqDetailExpander.prototype.getPlyaerStats = function () {
        if (this.props.viewType == "DEPMANAGER") {
            return null;
        }
        if (this.props.data.player_id <= 0) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0432\u0441\u0435 \u0432\u0440\u0435\u043C\u044F")),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_deposits_count,
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                " [",
                this.SDetails.DATA.total_withdraws_count,
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_deposit_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                " [",
                this.SDetails.DATA.total_withdraw_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0434\u0435\u043D\u0435\u0433 :"),
                " [",
                this.SDetails.DATA.total_bet_money_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0434\u0435\u043D\u0435\u0433 :"),
                " [",
                this.SDetails.DATA.total_win_money_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0441\u0442\u0430\u0432\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_bet_bonus_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0435\u0439 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_win_bonus_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u0431\u0440\u0435\u043D\u0434\u0430 :"),
                " [",
                this.SDetails.DATA.total_brand_profit_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0414\u043E\u0445\u043E\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 :"),
                " [",
                this.SDetails.DATA.total_partner_profit_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_bonus_completed_count,
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 :"),
                " [",
                this.SDetails.DATA.total_bonus_completed_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0439 :"),
                " [",
                this.SDetails.DATA.total_comission_deposit_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u0421\u0443\u043C\u043C\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0441\u043D\u044F\u0442\u0438\u0439 :"),
                " [",
                this.SDetails.DATA.total_comission_withdraw_amount.toFixed(2),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041E\u0442\u0434\u0430\u0447\u0430:"),
                " [",
                this.getTotalRtp(),
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u043E\u0432\u0430\u044F \u0437\u043E\u043D\u0430"),
                " [",
                this.getCustomZone(),
                "]"),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430\u043C\u0438:"),
                " [",
                this.SDetails.DATA.multiaccounts_count_by_withdraws,
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0442\u0435\u043C \u0436\u0435 ip:"),
                " [",
                this.SDetails.DATA.multiaccounts_count_by_ip,
                "] "),
            React.createElement("div", null,
                React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0442\u0435\u043C \u0436\u0435 \u043F\u0430\u0440\u043E\u043B\u0435\u043C:"),
                " [",
                this.SDetails.DATA.multiaccounts_count_by_password,
                "] ")));
    };
    DepositReqDetailExpander.prototype.getRenderObject = function () {
        if (this.props.viewType == "DEPMANAGER") {
            return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        this.props.data.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        this.props.data.date_added.format(this.state.dtFormat),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        this.props.data.date_changed.format(this.state.dtFormat),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                        " [",
                        this.props.data.description,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                        " [",
                        this.props.data.player_balance_before.toFixed(2),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                        " [",
                        this.props.data.player_balance_after.toFixed(2),
                        "]"))));
        }
        else {
            return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        this.props.data.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        this.props.data.date_added.format(this.state.dtFormat),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        this.props.data.date_changed.format(this.state.dtFormat),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                        " [",
                        this.props.data.description,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                        " [",
                        this.props.data.player_balance_before.toFixed(2),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                        " [",
                        this.props.data.player_balance_after.toFixed(2),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430 (\u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A):"),
                        " [",
                        this.props.data.exchange_rate_deposit_to_player,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "dt_time_to_expire :"),
                        " [",
                        this.props.data.dt_time_to_expire,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "dt_gws_tx_id:"),
                        " [",
                        this.props.data.dt_gws_tx_id,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "dt_url:"),
                        " [",
                        this.props.data.dt_url,
                        "]")),
                this.getPlyaerStats()));
        }
    };
    DepositReqDetailExpander.prototype.render = function () {
        return this.getRenderObject();
    };
    return DepositReqDetailExpander;
}(React.Component));
exports.default = DepositReqDetailExpander;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_deposits_list/ui/component/expander/DepositReqDetailExpander.tsx
// module id = 1990
// module chunks = 0